import { defineNuxtPlugin } from "#app";
import { createPersistedState } from "pinia-plugin-persistedstate";
import type { Pinia } from "pinia"; // Adjust the import based on your setup

export default defineNuxtPlugin((nuxtApp) => {
  const pinia = nuxtApp.$pinia as Pinia;
  if (import.meta.client) {
    pinia.use(createPersistedState());
  }
});
